/**
 * Etax Token удирдлагын төв файл
 * Бүх token-уудыг нэг газар удирдах
 */

export interface EtaxTokenData {
  access_token: string;
  refresh_token?: string;
  expires_in: number;
  refresh_expires_in?: number;
  token_type?: string;
}

/**
 * Legacy token support - localStorage-аас token авах
 */
export const getLegacyToken = (): string | null => {
  return localStorage.getItem('etax_token');
};

/**
 * Legacy token support - localStorage-д token хадгалах
 */
export const setLegacyToken = (token: string): void => {
 
  localStorage.setItem('etax_token', token);

};

/**
 * Etax tokens хадгалах
 */
export const saveEtaxTokens = (data: EtaxTokenData): void => {
  localStorage.setItem('etax_token', data.access_token);
  localStorage.setItem('etax_token_expiry', (new Date().getTime() + (data.expires_in * 1000)).toString());
  if (data.refresh_token) {
    localStorage.setItem('etax_refresh_token', data.refresh_token);
  }
};

/**
 * Etax tokens цэвэрлэх
 */
export const clearEtaxTokens = (): void => {

  localStorage.removeItem('etax_token');

  localStorage.removeItem('etax_token_expiry');
  localStorage.removeItem('etax_refresh_token');
  localStorage.removeItem('accountantOid');
  localStorage.removeItem('userRole');
  console.log('🔐 All Etax tokens and related data cleared from localStorage');
};

/**
 * Хүчинтэй Etax token авах
 */
export const getValidEtaxToken = (): { token: string | null; refreshToken: string | null; expiry: number | null } => {
  const token = localStorage.getItem('etax_token');
  const expiry = localStorage.getItem('etax_token_expiry');
  const refreshToken = localStorage.getItem('etax_refresh_token');

  if (token && expiry && new Date().getTime() < parseInt(expiry)) {
    return { token, refreshToken, expiry: parseInt(expiry) };
  }
  return { token: null, refreshToken: null, expiry: null };
};
